import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

var AppLoading = /*#__PURE__*/function (_Vue) {
  _inherits(AppLoading, _Vue);

  var _super = _createSuper(AppLoading);

  function AppLoading() {
    _classCallCheck(this, AppLoading);

    return _super.apply(this, arguments);
  }

  return AppLoading;
}(Vue);

__decorate([Prop(String)], AppLoading.prototype, "text", void 0);

AppLoading = __decorate([Component], AppLoading);
export default AppLoading;